<template>
    <div class="py-2 my-2" :class="{ hidden: isPartHidden }" data-testid="search-part">
        <SearchPartHeader :result="part">
            <template #actions><slot name="actions"></slot></template>
            <template #chart><slot name="chart"></slot></template>
        </SearchPartHeader>
        <SearchPartResults v-if="part.PartResults?.length" :parts="part.PartResults" show-distributor />
        <p v-else class="border border-t-0 px-2 py-3">{{ $t("Search.NoDistributorOffers") }}</p>
    </div>
</template>
<script setup lang="ts">
import type { PartDetailResultGroup } from "~/utils/search";

const searchIds = inject(SearchIdsInjectKey);

const isPartHidden = computed(() => !searchIds?.partKeys.value.has(part.Key));

const { part } = defineProps<{ part: PartDetailResultGroup }>();
</script>
